import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, ButtonWrapper, DivInput, TextInput } from './Styled';

import Button from '../common/Button/Button';
import { highlightYellow } from '../../styles/styled/colors';

const KEY_ENTER = 13;

class TqlQueryInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            query : '',
            runDisabled: this.props.runDisabled,
        };
    }

    componentWillMount() {
        this.setState({ query: this.generateMultiColouredString(this.props.query)});
    }

    handleOnInput = (e) => {
        this.setState({query: e.target.value});
        this.props.updateQuery(e.target.value);
    }

    handleOnClick = () => {
        this.setState({query: this.props.query}, () => {
            this.props.toggleModal();
        });
    }

    handleKeyDown = (e) => {
        if(e.keyCode === KEY_ENTER) {
            this.props.runClicked();
        }
    }

    generateMultiColouredString = (str) => {
        let chars = str.split('');
        let html = '';
        chars.forEach(char => {
            if (char !== '{' && char !== '}') {
                html += char;
            } else if (char === '{') {
               html += (`<div style='display:inline; background-color:${highlightYellow}'>` + char);
            } else if (char === '}') {
                html += (char + '</div>');
            }
        });
        return html;

    }

    render() {
        const input = (!this.props.isEditing ?
        <DivInput id={this.props.id} onClick={this.handleOnClick} dangerouslySetInnerHTML={{ __html: this.generateMultiColouredString(this.props.query) }}></DivInput> :
        <TextInput id={this.props.id} value={this.props.query} onChange={this.handleOnInput} onKeyDown={this.handleKeyDown} />)

        return (
            <Wrapper>
                {input}
                <ButtonWrapper>
                    <Button id="button-reset" text='Reset' onClick={this.props.resetClicked} className='btn mb-1'/>
                    <Button id="button-run" text="Run" onClick={this.props.runClicked} className="btn btn-primary ml-2 mb-1" isLoading={this.props.loading} disabled={this.props.runDisabled}/>
                </ButtonWrapper>
            </Wrapper>
        );
    }

}


TqlQueryInput.propTypes = {
    query: PropTypes.string,
}

export default TqlQueryInput;



// WEBPACK FOOTER //
// ./src/components/TqlQueryInput/TqlQueryInput.js